import TextField from 'shared/components/form/TextField';
import { CreateBotsLinkFormT } from '../../form-values/links';
import { useGetChannels } from '../../api/requests/channels';
import Field from '../../components/form/Field';
import {useTranslation} from 'react-i18next'

const ChannelsLinkForm = () => {
  const {t} = useTranslation();
  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <Field
        type="async-select"
        name="channelId"
        label={t('forms.channelId')}
        required
        placeholder={t('forms.selectChannelId')}
        optionsQuery={useGetChannels}
        labelName="name"
        valueName="id"
        defaultValue={null}
        {...fieldProps}
      />
      <TextField<CreateBotsLinkFormT>
        name="source"
        label={t('forms.source')}
        placeholder={t('forms.enterSource')}
        {...fieldProps}
        mt={5}
      />
      <TextField<CreateBotsLinkFormT>
        name="buyer"
        label={t('forms.buyer')}
        placeholder={t('forms.enterBuyer')}
        {...fieldProps}
      />
      <TextField<CreateBotsLinkFormT>
        name="fbPixel"
        label={t('forms.fbPixel')}
        placeholder={t('forms.enterFbPixel')}
        {...fieldProps}
      />
      <TextField<CreateBotsLinkFormT>
        name="fbToken"
        label={t('forms.fbToken')}
        placeholder={t('forms.enterFbToken')}
        {...fieldProps}
      />
    </>
  );
};

export default ChannelsLinkForm;
